module.exports = __webpack_public_path__ + "media/application/images/svgs/user-minus-aea787aaac28a58ad45fb4a7b63301a2.svg";